module.exports = __webpack_public_path__ + "static/media/RP-50.952a7d0b.pdf";